/**
 * cart-addons.js — Bloom Kids
 *
 * "Embrulhar como presente" (+0,50€) e "Incluir saco" (+0,35€) — modelo
 * de checkbox única para o carrinho todo (ponto 2 do feedback de 13 Ago,
 * ajustado para funcionar como na Barriguitas): ao marcar, adiciona o
 * produto-taxa correspondente como uma linha normal do carrinho, com a
 * sua própria quantidade e botão de remover. O cliente indica na Nota do
 * carrinho a que produtos se destina cada embrulho/saco — é por isso que
 * este ficheiro cria o popup com essa explicação diretamente em
 * JavaScript e adiciona-o ao <body>, em vez de o pôr dentro do snippet
 * cart-addons-toggle.liquid: assim o popup não é apagado/reiniciado
 * sempre que o drawer do carrinho atualiza o seu conteúdo.
 *
 * Ficheiro independente do bundle do tema (main-*.js, gerado pelo Vite) —
 * não editar esse ficheiro; este script funciona à parte, ouvindo as
 * checkboxes do snippet cart-addons-toggle.liquid e falando diretamente
 * com a Ajax Cart API da Shopify.
 *
 * IMPORTANTE: os dois variant IDs abaixo têm de corresponder aos
 * produtos-taxa "Embrulho de Presente" e "Saco de Entrega" (criados no
 * admin — ver guia).
 */

(function () {
  'use strict';

  var ADDON_VARIANT_IDS = {
    'gift-wrap': 53891274735944, // "Embrulho"
    'bag': 53891281158472 // "Saco"
  };

  var NOTE_POPUP_TEXT =
    'Indique na nota do carrinho quais os produtos que pretende embrulhar como presente e/ou colocar num saco separado. Se precisar de mais do que um embrulho ou saco, aumente a quantidade desse artigo aqui no carrinho.';

  function routes() {
    return window.routes || {};
  }

  function getCartState() {
    return fetch(routes().root_url + 'cart.js').then(function (response) {
      return response.json();
    });
  }

  function addAddon(addonType) {
    return fetch(routes().cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: ADDON_VARIANT_IDS[addonType],
            quantity: 1,
            properties: {
              _addon_type: addonType
            }
          }
        ]
      })
    });
  }

  function removeAddon(addonType) {
    return getCartState().then(function (cart) {
      var line = cart.items.find(function (it) {
        return it.properties && it.properties._addon_type === addonType;
      });
      if (!line) {
        return null;
      }
      return fetch(routes().cart_change_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: line.key, quantity: 0 })
      });
    });
  }

  // Atualiza o carrinho "por dentro" (sem recarregar a página inteira),
  // usando o próprio mecanismo do tema Aurora para o drawer do carrinho
  // (o mesmo que corre quando alteras a quantidade de um artigo). Isto
  // evita o "salto" para fora da página / para o checkout que acontecia
  // com um window.location.reload() a meio da navegação.
  function refreshCart() {
    var refreshedSomething = false;

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.update === 'function') {
      refreshedSomething = true;
      cartDrawer.update();
    }

    var liveCartPage = document.getElementById('CartPage');
    if (liveCartPage) {
      refreshedSomething = true;
      fetch(routes().cart_url)
        .then(function (response) {
          return response.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var freshCartPage = doc.getElementById('CartPage');
          var currentCartPage = document.getElementById('CartPage');
          if (freshCartPage && currentCartPage) {
            currentCartPage.replaceWith(freshCartPage);
          }
        })
        .catch(function () {
          window.location.reload();
        });
    }

    if (!refreshedSomething) {
      // Rede de segurança: se por algum motivo não encontrámos nem o
      // drawer nem a página do carrinho, recarregamos como antes.
      window.location.reload();
    }
  }

  // O popup é criado aqui em JavaScript e colado diretamente no <body>
  // — fora do drawer do carrinho — para não ser apagado quando o drawer
  // atualiza o seu conteúdo (era essa a causa do popup "desaparecer
  // sozinho"). Só é criado uma vez; chamadas seguintes reutilizam-no.
  function ensureNotePopup() {
    var popup = document.querySelector('[data-cart-addons-note-popup]');
    if (popup) {
      return popup;
    }

    popup = document.createElement('div');
    popup.className = 'cart-addons-note-popup hidden';
    popup.setAttribute('data-cart-addons-note-popup', '');
    popup.innerHTML =
      '<div class="cart-addons-note-popup__box">' +
      '<p>' + NOTE_POPUP_TEXT + '</p>' +
      '<button type="button" class="btn btn--primary" data-cart-addons-note-popup-close>Entendido</button>' +
      '</div>';
    document.body.appendChild(popup);
    return popup;
  }

  function showNotePopup() {
    ensureNotePopup().classList.remove('hidden');
  }

  function hideNotePopup() {
    var popup = document.querySelector('[data-cart-addons-note-popup]');
    if (popup) {
      popup.classList.add('hidden');
    }
  }

  function handleToggleChange(event) {
    var checkbox = event.target;
    if (!checkbox.classList || !checkbox.classList.contains('js-cart-addon-toggle')) {
      return;
    }

    var addonType = checkbox.dataset.addon; // 'gift-wrap' ou 'bag'

    if (!ADDON_VARIANT_IDS[addonType]) {
      console.error(
        'cart-addons.js: falta configurar o variant ID de "' + addonType + '" em ADDON_VARIANT_IDS.'
      );
      checkbox.checked = !checkbox.checked;
      return;
    }

    checkbox.disabled = true;

    var request = checkbox.checked ? addAddon(addonType) : removeAddon(addonType);

    request
      .then(function () {
        checkbox.disabled = false;
        if (checkbox.checked) {
          showNotePopup();
        }
        refreshCart();
      })
      .catch(function (error) {
        console.error('cart-addons.js: erro ao atualizar o carrinho.', error);
        checkbox.disabled = false;
        checkbox.checked = !checkbox.checked;
      });
  }

  function handlePopupClick(event) {
    if (event.target.closest && event.target.closest('[data-cart-addons-note-popup-close]')) {
      hideNotePopup();
    }
  }

  function init() {
    ensureNotePopup();
    document.addEventListener('change', handleToggleChange);
    document.addEventListener('click', handlePopupClick);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();